import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-61807402")

_pushScopeId("data-v-61807402")
const _hoisted_1 = {
  class: "container popup-container",
  id: "providers-filter"
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "providers-filter-title" }
const _hoisted_4 = { class: "filter-block" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { for: "provider-name" }
const _hoisted_7 = { class: "position-relative" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { for: "product-name" }
const _hoisted_10 = { class: "position-relative" }
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { for: "product-select" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { for: "product-select" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { for: "provider-status-select" }
const _hoisted_19 = { class: "position-relative" }
const _hoisted_20 = { class: "filter-block-footer" }
const _hoisted_21 = { class: "second-row-btns" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "middle-hidden-block" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_Calendar = _resolveComponent("Calendar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('button.filters')), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('promo.providerName')), 1),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_Multiselect, _mergeProps({
              class: { 'form-controll-multiselect': !_ctx.filter.providerId },
              modelValue: _ctx.filter.providerId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.providerId = $event))
            }, _ctx.providerSelect, {
              onChange: _ctx.providerChanged,
              options: _ctx.providers
            }), null, 16, ["class", "modelValue", "onChange", "options"]),
            (_ctx.filter.providerId)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.providerId = null))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('product.productName')), 1),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_Multiselect, _mergeProps({
              class: { 'form-controll-multiselect': !_ctx.filter.productId },
              required: "",
              modelValue: _ctx.filter.productId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.productId = $event))
            }, _ctx.productSelect, { options: _ctx.filteredProducts }), null, 16, ["class", "modelValue", "options"]),
            (_ctx.filter.productId)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.productId = null))
                }))
              : _createCommentVNode("", true),
            _createVNode("span", _hoisted_11, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('promo.fromDate')), 1),
          _createVNode("div", null, [
            _createVNode(_component_Calendar, {
              onDateSelect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dateChanged(_ctx.promoDateRange))),
              modelValue: _ctx.promoDateRange.fromDate,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.promoDateRange.fromDate = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('promo.toDate')), 1),
          _createVNode("div", null, [
            _createVNode(_component_Calendar, {
              onDateSelect: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dateChanged(_ctx.promoDateRange))),
              modelValue: _ctx.promoDateRange.toDate,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.promoDateRange.toDate = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy",
              minDate: _ctx.promoDateRange.fromDate
            }, null, 8, ["modelValue", "minDate"])
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('providers.isActive')), 1),
          _createVNode("div", _hoisted_19, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.filter.active,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.filter.active = $event)),
              valueProp: "id",
              label: "name",
              options: _ctx.activityStatuses(),
              id: "provider-status-select",
              "close-on-select": true
            }, null, 8, ["modelValue", "options"]),
            (_ctx.filter.active != null)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.filter.active = null))
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_20, [
        _createVNode("div", null, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.Search && _ctx.Search(...args))),
            class: "search-filter-button"
          }, _toDisplayString(_ctx.$t('button.search')), 1)
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.Close && _ctx.Close(...args)))
          }, _toDisplayString(_ctx.$t('button.close')), 1),
          _hoisted_22,
          _createVNode("button", {
            type: "button",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.ResetFilter && _ctx.ResetFilter(...args)))
          }, _toDisplayString(_ctx.$t('button.clearAll')), 1)
        ])
      ])
    ])
  ]))
})